import { alias, list, object, primitive, serializable } from "serializr";

export class GroupDetailsModel {
  @serializable
  name?: string;

  @serializable(alias("registration_document", primitive()))
  registration_document?: File;
}

export class GroupDetailsBasicDetailsModel {
  @serializable
  id?: string;

  @serializable
  type?: string;

  @serializable(alias("kenyan_national_number", primitive()))
  kenyanNationalNumber?: string;

  @serializable(alias("KRA_pin_number", primitive()))
  kraPinNumber?: string;

  @serializable(alias("date_of_birth", primitive()))
  dateOfBirth?: string;

  @serializable(alias("nationality_id", primitive()))
  nationalityId?: string;

  @serializable(alias("country_of_residence_id", primitive()))
  countryOfResidenceId?: string;

  @serializable(alias("employment_status_id", primitive()))
  employmentStatusId?: string;

  @serializable(alias("gender_id", primitive()))
  genderId?: string;
}

export class GroupDetailsMembersModel {
  @serializable(primitive())
  id?: string;

  @serializable(primitive())
  email?: string;

  @serializable(alias("first_name", primitive()))
  firstName?: string;

  @serializable(alias("middle_name", primitive()))
  middleName?: string;

  @serializable(alias("last_name", primitive()))
  lastName?: string;

  @serializable(alias("is_secondary", primitive()))
  isSecondary?: boolean = false;
}

export class GroupMembers {
  @serializable(alias("members", list(object(GroupDetailsMembersModel))))
  members?: GroupDetailsMembersModel[] = [new GroupDetailsMembersModel()];

  @serializable
  name?: string;
}

export class SSOLoginModel {
  @serializable
  url?: string;

  @serializable(alias("google_oauth_state", primitive()))
  googleOauthState?: string;
}

export class SSORegisterModel {
  @serializable
  state?: string;

  @serializable
  code?: string;

  @serializable(alias("google_oauth_state", primitive()))
  googleOauthState?: string;
}

export class AppleAuthModel {
  @serializable(alias("id_token", primitive()))
  id_token?: string;

  @serializable
  register?: boolean;

  @serializable(alias("account_type", primitive()))
  account_type?: string;

  @serializable(alias("first_name", primitive()))
  first_name?: string;

  @serializable(alias("last_name", primitive()))
  last_name?: string;

  @serializable(alias("invite_code", primitive()))
  invite_code?: string;

  @serializable(alias("referral_code", primitive()))
  referral_code?: string;
}
